import CodeIcon from '@mui/icons-material/Code';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { EditFileToolArguments } from 'services/types/ticket';

import MessageWrapper from './MessageWrapper';
import TextEdit from './TextEdit';

interface Props {
  args: string;
}

const EditFileToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: EditFileToolArguments;

  try {
    parsedArgs = JSON.parse(args) as EditFileToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Edición" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Editar archivo" align="left">
      <Box>
        <Box
          sx={{
            mb: 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <EditIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Archivo:
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
            {parsedArgs.targetFile}
          </Typography>
        </Box>

        <Box
          sx={{
            mb: 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <CodeIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Modificaciones:
          </Typography>
          <Box
            sx={{
              height: '300px',
              minHeight: '150px',
              maxHeight: '800px',
              overflow: 'auto',
              resize: 'vertical',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              p: 1,
            }}
          >
            <TextEdit codeEdit={parsedArgs.codeEdit || ''} />
          </Box>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default EditFileToolComponent;
